<aside class="sidebar chrome-tabs">
  <div class="tab-list">
    @for (tab of tabs; track tab.id; let index = $index) {
      <div
        class="tab-item"
        role="button"
        tabindex="{{ index }}"
        [class.active]="tab.id === activeTabId"
        (click)="onSwitchTab(tab.id)"
        [title]="getDisplayTitle(tab)"
      >
        <span class="tab-title">{{ getDisplayTitle(tab) }}</span>
        <button
          type="button"
          class="close-tab"
          aria-label="Close tab"
          (click)="onCloseTab($event, tab.id)"
          [hidden]="tab.id === tabs[0].id"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
    }
  </div>
</aside>
  
